module.exports = __webpack_public_path__ + "static/media/image-effect-preview-pc.1c94044d.png";